import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import {IconComponent} from "../../reusable/simpleComponents";
import {ApplicationState} from "../../../store";
import {TimelineState} from "../../../store/timeline/types";
import {setPlaybackmode} from "../../../store/timeline/actions";
import {LayoutState} from "../../../store/layouts/types";
import {BookmarkState} from "../../../store/bookmarks/types";
import {RouterState} from "connected-react-router";
import {BrowseState} from "../../../store/browse/types";
import { Routes } from '../../../types';


const RunForwardUIComponent = () => {
    const { browsePanes } = useSelector<ApplicationState, BrowseState>(state => state.browse);
    const { playbackMode, changeIconView } = useSelector<ApplicationState, TimelineState>(state => state.timeline);
    const { checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { bookmarks } = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
    const { location } = useSelector<ApplicationState, RouterState>(state => state.router);
    const dispatch = useDispatch();

    
    const active = playbackMode === 'play';
    const handler = () => {

        const panes = location.pathname === Routes.bookmarks ? bookmarks : browsePanes;
        if (checkedPane === null) return;
        if (!panes[checkedPane]) return;

        if (playbackMode !== 'pause') dispatch(setPlaybackmode('pause', false));
        setTimeout(function () {
            !active && dispatch(setPlaybackmode('play'));
        }, 500);
    };

    return (
        <>
            <IconComponent classValue={active && changeIconView ? 'player active play icon playback-icon' : 'player play icon playback-icon'}
                           handler={handler}
                           title="Play Forward"
            />
        </>
    )
};

export default RunForwardUIComponent